import React from "react";
import AnimatedHeroText from "js/components-v2/common/AnimatedHeroText/AnimatedHeroText";
import AnimatedItem from "js/components-v2/common/AnimatedHeroText/AnimatedItem";
import StartNow from "js/components-v2/common/StartNow/StartNow";
import Icon from "js/components-v2/common/StartNow/Icon";
import HeroButtons from "js/components-v2/pages/BuyerPage/HeroButtons";
import BuyerVideo from "js/components-v2/pages/BuyerPage/BuyerVideo";
import userCountry from 'js/services/UserCountry';
import {formatCurrency} from "js/services/Format";

const HeroSection = () => {
  const [active, setActive] = React.useState(0);

  return (
    <>
      <div className="hero-text">
        {userCountry() !== 'NG' ? (
          <StartNow>
            <Icon src="/images/v2/dollar-circle.svg" alt="Start now and get $25"/>
            <span>Get <strong>$25</strong> gift that you can use on your purchases</span>
          </StartNow>
        ):(
          <StartNow>
            {/*<Icon src="/images/v2/dollar-circle.svg" alt="Start now and get 3500"/>*/}
            <span>Get <strong>{formatCurrency(3500, 'NGN')}</strong> gift to use on your purchases today!</span>
          </StartNow>
        )}
        <div className="hero-section">
          <AnimatedHeroText>
            <AnimatedItem className={0 === active ? 'active' : ''}>
              {userCountry() !== 'NG' ? (
                <h1>Best marketplace deals don’t last</h1>
              ) : (
                <h1>Buy safer online</h1>
              )}
              <p>PayOnDelivery takes the risk out of marketplace shopping. Grab the best deal to get it delivered
                with in 24h and pay only after verification.</p>
            </AnimatedItem>

            <AnimatedItem className={1 === active ? 'active' : ''}>
              <h1>Securely pay sellers and get it delivered same day</h1>
              <p>PayOnDelivery takes the risk out of marketplace shopping. Grab the best deal to get it delivered
                with in 24h and pay only after verification.</p>
            </AnimatedItem>

            <AnimatedItem className={2 === active ? 'active' : ''}>
              <h1>Pay only after delivery</h1>
              <p>PayOnDelivery takes the risk out of marketplace shopping. Grab the best deal to get it delivered
                with in 24h and pay only after verification.</p>
            </AnimatedItem>
          </AnimatedHeroText>
        </div>
        <HeroButtons/>
      </div>
      <div className="hero-media d-md-flex align-items-center">
        <BuyerVideo setActive={setActive} active={active} />
      </div>
    </>
  );
}

export default HeroSection;
